import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Typography,
  Upload,
} from "antd";

import JoditEditor from "jodit-react";
import { CiImageOn } from "react-icons/ci";
import { LuSend } from "react-icons/lu";
import { useEffect, useState } from "react";
import {
  BASE_URL,
  COACH,
  COMMUNITY,
  UPLOAD_URL2,
} from "../../config/constants/api";
import { CONTENT_TYPE } from "../../config/constants/index";
import { Post } from "../../config/api/post";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { message } from "antd";
import { Get } from "../../config/api/get";
import { useLocation } from "react-router";
import axios from "axios";
import { ImageUrl } from "../../helpers/Functions";

export default function CreateForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const post = location?.state?.post;
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);

  const config = {
    readonly: false,
    placeholder: "Enter Post Description",
  };

  const [students, setStudents] = useState([]);
  const [communityMembers, setCommunityMembers] = useState([]);
  const [, setLoading3] = useState(false);

  const getMyStudents = async (pageNumber) => {
    setLoading3(true);
    try {
      const response = await Get(COACH.getMyStudents, token, {
        page: "1",
        limit: "10",
      });
      setLoading3(false);
      if (response?.status) {
        setStudents(response?.data?.students);
      } else {
        // message.error(response.message);
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading3(false);
    }
  };
  useEffect(() => {
    getMyStudents();
    if (post?.members?.length > 0) {
      post.members.forEach((member) => {
        setCommunityMembers((prev) => [...prev, member._id]);
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [fileListImage, setFileListImage] = useState([]);
  const handleImageChange = ({ fileList }) => setFileListImage(fileList);

  const onFinish = (values) => {
    setLoading(true);
    const formObject = new FormData();

    const data = {
      title: values.title,
      description: values.description,
    };

    for (const key in data) {
      if (key !== "image") {
        formObject.append(
          key,
          Array.isArray(data[key]) ? JSON.stringify(data[key]) : data[key]
        );
      }
    }

    // Append image files individually
    if (fileListImage.length > 0) {
      fileListImage.forEach((file) => {
        formObject.append("image", file.originFileObj); // Append each image file
      });
    }

    let members = JSON.stringify([]);

    if (communityMembers.length > 0) {
      members = JSON.stringify(communityMembers);
    }

    formObject.append("members", members);

    Post(COMMUNITY.addPost, formObject, token, null, CONTENT_TYPE.FORM_DATA)
      .then((response) => {
        setLoading(false);
        console.log(response);
        if (response?.data?.status) {
          swal("Success", "Post added successfully", "success");
          navigate(-1);
        } else {
          swal(
            "Oops!",
            response?.data?.message || response?.response?.data?.message,
            "error"
          );
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        message.error("An error occurred while adding the post.");
      });
  };

  async function updatePost(values) {
    setLoading(true);
    let data = new FormData();
    data.append("title", values.title);
    data.append("description", values.description);
    data.append("members", JSON.stringify(communityMembers));
    data.append("image", fileListImage[0]?.originFileObj || post?.thumbnail);

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BASE_URL}/community/${post._id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        console.log("responst", response);
        if (response.status === 200) {
          swal("Success", "Post Updated successfully", "success");
          navigate(-1);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        swal(
          "Oops!",
          error || error?.response?.data?.message || "Something went wrong",
          "error"
        );
      });
  }

  function addCommunityMember(id) {
    let temp = [...communityMembers];
    if (temp.includes(id)) {
      temp = temp.filter((item) => item !== id);
    } else {
      temp.push(id);
    }
    setCommunityMembers(temp);
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground"
        style={{
          height: "45vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography.Title
          className="fontFamily1"
          style={{
            fontSize: "30px",
            color: "#333d47",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          {<> Community</>}
        </Typography.Title>
      </Row>

      {/* List of User */}
      <Row className="md:mx-36 my-5">
        <Col
          xs={24}
          lg={8}
          style={{ display: "flex", justifyContent: "start" }}
        >
          <div className="h-screen overflow-hidden w-full bg-slate-200 mx-6 sm:mx-0">
            <p className="text-center my-6 text-4xl font-semibold">
              Add students to community
            </p>

            <div className="h-[1000px] overflow-y-auto">
              <div className="mt-8  px-2 sm:px-6 flex flex-col gap-10 items-start">
                {students.length > 0 ? (
                  students.map((user, index) => (
                    <div
                      key={index}
                      className="flex justify-between w-full items-center gap-4"
                    >
                      <div className="flex justify-start items-center gap-4">
                        <img
                          src={
                            user?.image
                              ? UPLOAD_URL2 + user.image
                              : ImageUrl("avatar.png")
                          }
                          alt="Member"
                          className="w-24 h-24 rounded-full"
                        />
                        <p className="text-3xl  font-semibold">
                          {user.firstName + " " + user.lastName}
                        </p>
                      </div>
                      <input
                        onChange={() => addCommunityMember(user._id)}
                        type="checkbox"
                        checked={communityMembers.includes(user._id)}
                      />
                    </div>
                  ))
                ) : (
                  <p className="text-2xl w-full font-semibold text-center">
                    No User Found
                  </p>
                )}
              </div>
            </div>
          </div>
        </Col>

        {/* Form */}
        <Col
          xs={24}
          lg={16}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="h-full lg:h-screen w-full bg-white  my-10 sm:my-0 mx-4 sm:mx-0 sm:px-24 ">
            <p className="text-5xl my-5 font-extrabold">Create form</p>

            <Form
              initialValues={{
                title: post?.title || "",
                description: post?.description || "",
              }} // Set initial value of 'title'
              name="post-add"
              onFinish={post ? updatePost : onFinish}
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              className=" flex justify-start items-start flex-col gap-5"
            >
              {/* For Inputs */}
              <Form.Item
                label="Post Title"
                name="title"
                rules={[
                  { required: true, message: "Please input Post Title!" },
                ]}
                className="w-full"
              >
                <Input
                  value={post?.title}
                  size="large"
                  placeholder="Enter Post Title"
                  style={{ width: "95%" }}
                  className="h-16 p-2 md:ml-20 border-[1px] border-slate-300 focus:outline-none"
                />
              </Form.Item>

              <Form.Item
                label="Post Description"
                name="description"
                className="w-full"
                rules={[
                  { required: true, message: "Please enter Post Description!" },
                ]}
              >
                <JoditEditor
                  value={post?.description || ""}
                  className="p-2  border-[1px] border-slate-300 focus:outline-none"
                  config={config}
                />
              </Form.Item>

              {post?.thumbnail && (
                <Form.Item className="w-full">
                  <img
                    src={UPLOAD_URL2 + post.thumbnail}
                    alt="thumbnail"
                    className="mx-auto w-[500px] h-[300px] "
                  />
                </Form.Item>
              )}

              {/* Post Image Upload */}
              <div className="flex flex-col md:flex-row md:justify-between items-start gap-4 w-full">
                <Form.Item
                  label="Post Image"
                  name="image"
                  rules={[
                    {
                      required: post?.thumbnail ? false : true,
                      message: "Please upload an image!",
                    },
                  ]}
                >
                  <Upload
                    listType="picture"
                    fileList={fileListImage}
                    onChange={handleImageChange}
                    accept="image/*"
                    maxCount={1}
                  >
                    <Button
                      className="flex justify-center items-center md:ml-20"
                      type="primary"
                      icon={<CiImageOn size={20} />}
                    >
                      {post?.thumbnail ? "update Image" : "Add Image"}
                    </Button>
                  </Upload>
                </Form.Item>
                {/* For Buttons */}
                <div className="flex flex-col md:flex-row-reverse gap-0  md:gap-4 md:mt-[-10px] ">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      icon={!loading && <LuSend size={20} />}
                      className="bg-[#00A79D] hover:bg-[#1d827b] focus:bg-[#1d827b] text-white w-48 h-14 rounded-xl flex justify-center items-center gap-4 md:mt-5"
                    >
                      {loading ? (
                        <div class="w-8 h-8 border-4 border-dashed border-t-4 border-white   rounded-full animate-spin"></div>
                      ) : post ? (
                        "Update"
                      ) : (
                        "Publish"
                      )}
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}
